import moment from 'moment';

export const encodeDate = (date: Date) => date.toISOString();

export const formatDate = (date: string | undefined) => {
	if (!date) return '';
	const mDate = moment(date).format('MM/DD/YYYY HH:mm');
	return mDate;
};
